<template>
  <div class="example-container">
    <h2>背景图片 + 定位图片组件使用示例</h2>
    
    <!-- 示例1：基本用法 -->
    <div class="example-section">
      <h3>示例1：基本用法</h3>
      <BackgroundWithOverlay
        background-image="@/assets/images/example-bg.jpg"
        overlay-image="@/assets/images/example-overlay.png"
        container-height="400px"
        overlay-top="50px"
        overlay-left="50px"
        overlay-width="300px"
        overlay-height="200px"
        overlay-border-radius="20px"
        overlay-box-shadow="0 4px 16px rgba(0, 0, 0, 0.2)"
      />
    </div>

    <!-- 示例2：全屏背景 -->
    <div class="example-section">
      <h3>示例2：全屏背景</h3>
      <BackgroundWithOverlay
        background-image="@/assets/images/example-bg.jpg"
        overlay-image="@/assets/images/example-overlay.png"
        container-height="100vh"
        overlay-top="20%"
        overlay-left="10%"
        overlay-width="500px"
        overlay-height="300px"
        overlay-border-radius="30px"
        overlay-box-shadow="0 8px 32px rgba(0, 0, 0, 0.3)"
      />
    </div>

    <!-- 示例3：居中定位 -->
    <div class="example-section">
      <h3>示例3：居中定位</h3>
      <BackgroundWithOverlay
        background-image="@/assets/images/example-bg.jpg"
        overlay-image="@/assets/images/example-overlay.png"
        container-height="500px"
        overlay-top="50%"
        overlay-left="50%"
        overlay-width="400px"
        overlay-height="250px"
        overlay-border-radius="15px"
        overlay-box-shadow="0 6px 24px rgba(0, 0, 0, 0.25)"
      />
    </div>

    <!-- 示例4：HTML内容模式 -->
    <div class="example-section">
      <h3>示例4：HTML内容模式（品牌故事卡片）</h3>
      <BackgroundWithOverlay
        background-image="@/assets/images/xixinguanzhao-bg.png"
        :use-html-content="true"
        container-height="600px"
        overlay-top="100px"
        overlay-left="100px"
        overlay-width="500px"
        overlay-height="400px"
        overlay-border-radius="40px"
        overlay-box-shadow="0 8px 32px rgba(0, 0, 0, 0.15)"
        @learn-more-click="handleLearnMoreClick"
      />
    </div>
  </div>
</template>

<script>
import BackgroundWithOverlay from './BackgroundWithOverlay.vue'

export default {
  name: 'BackgroundWithOverlayExample',
  components: {
    BackgroundWithOverlay
  },
  methods: {
    handleLearnMoreClick() {
      console.log('了解更多按钮被点击');
      // 这里可以添加跳转逻辑
    }
  }
}
</script>

<style scoped>
.example-container {
  padding: 20px;
}

.example-section {
  margin-bottom: 40px;
}

.example-section h3 {
  margin-bottom: 20px;
  color: #333;
  font-size: 18px;
}
</style> 